import { Sparkles, BookOpen, Drama, User } from "lucide-react";

interface TabBarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  dark?: boolean;
}

const tabs = [
  { id: "target", label: "今日", icon: Sparkles },
  { id: "arsenal", label: "弹药库", icon: BookOpen },
  { id: "battle", label: "排练室", icon: Drama },
  { id: "profile", label: "成长", icon: User },
];

const getThemeColor = (tabId: string) => {
  switch (tabId) {
    case "target":
      return "#6B9E85";
    case "arsenal":
      return "#D4B86A";
    case "battle":
      return "#8B5CF6";
    case "profile":
      return "#7BAAB7";
    default:
      return "#7B5FC4";
  }
};

const getThemeBg = (tabId: string) => {
  switch (tabId) {
    case "target":
      return "rgba(221, 246, 232, 0.2)";
    case "arsenal":
      return "rgba(255, 243, 216, 0.2)";
    case "battle":
      return "rgba(189, 169, 255, 0.15)";
    case "profile":
      return "rgba(234, 244, 255, 0.2)";
    default:
      return "rgba(189, 169, 255, 0.18)";
  }
};

export default function TabBar({ activeTab, onTabChange }: TabBarProps) {
  return (
    <div className="absolute bottom-0 left-0 right-0 z-50 px-5 pb-6 pt-2">
      <div
        className="flex items-center justify-around h-[64px] rounded-[28px] px-3 glass-tabbar"
      >
        {tabs.map((tab) => {
          const Icon = tab.icon;
          const isActive = activeTab === tab.id;
          const themeColor = getThemeColor(tab.id);
          const themeBg = getThemeBg(tab.id);
          return (
            <button
              key={tab.id}
              onClick={() => onTabChange(tab.id)}
              className="flex flex-col items-center justify-center gap-1 px-3 py-2 animate-spring"
              style={{ transform: isActive ? "scale(1)" : "scale(0.92)" }}
            >
              <div
                className="flex items-center justify-center rounded-full transition-all duration-300"
                style={{
                  width: isActive ? 36 : 28,
                  height: isActive ? 36 : 28,
                  background: isActive ? themeBg : "transparent",
                }}
              >
                <Icon
                  size={22}
                  strokeWidth={2}
                  className="transition-colors duration-300"
                  style={{
                    color: isActive
                      ? themeColor
                      : "#AEABBA",
                  }}
                />
              </div>
              <span
                className="text-[10px] font-medium transition-all duration-300"
                style={{
                  color: isActive
                    ? themeColor
                    : "#AEABBA",
                }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}